// We keep the type for the enum in a separate file so that we can import it
// into both client and server code.
import { type EnumObjectValues, type EnumObjectKeys } from '~/utils/types.ts'

export const RoleEnum = {
  USER: 'user',
  PROFESSIONAL: 'professional',
  ADMIN: 'admin',
  INVITER: 'inviter',
} as const
export type RoleType = EnumObjectValues<typeof RoleEnum>
export type RoleKeysType = EnumObjectKeys<typeof RoleEnum>

export const StatusEnum = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  PENDING: 'pending',
  ALL: 'all',
  DELETED: 'deleted',
} as const
export type StatusType = EnumObjectValues<typeof StatusEnum>
export type StatusKeysType = EnumObjectKeys<typeof StatusEnum>

// domingo primero, en js domingo es el dia 0
export const WeekDayEnum = {
  SUNDAY: 'Domingo',
  MONDAY: 'Lunes',
  TUESDAY: 'Martes',
  WEDNESDAY: 'Miércoles',
  THURSDAY: 'Jueves',
  FRIDAY: 'Viernes',
  SATURDAY: 'Sábado',
} as const
export type WeekDayType = EnumObjectValues<typeof WeekDayEnum>
export type WeekDayKeysType = EnumObjectKeys<typeof WeekDayEnum>

export const WeekDayAbrevEnum = {
  MONDAY: 'Lun',
  TUESDAY: 'Mar',
  WEDNESDAY: 'Mie',
  THURSDAY: 'Jue',
  FRIDAY: 'Vie',
  SATURDAY: 'Sab',
  SUNDAY: 'Dom',
  //continuar con todos los dias de la semana sin usar acentos
} as const
export type WeekDayAbrevType = EnumObjectValues<typeof WeekDayAbrevEnum>
export type WeekDayAbrevKeysType = EnumObjectKeys<typeof WeekDayAbrevEnum>

export const LanguageEnum = {
  SPANISH: 'Español',
  ENGLISH: 'Inglés',
  FRENCH: 'Francés',
  CATALAN: 'Catalán',
  BASQUE: 'Euskera',
  ITALIAN: 'Italiano',
} as const
export type LanguageType = EnumObjectValues<typeof LanguageEnum>
export type LanguageKeysType = EnumObjectKeys<typeof LanguageEnum>

export const CouponStatusEnum = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  CLOSED: 'closed',
  DELETED: 'deleted',
} as const
export type CouponStatusType = EnumObjectValues<typeof CouponStatusEnum>
export type CouponStatusKeysType = EnumObjectKeys<typeof CouponStatusEnum>

/** Intents for admin course save (structure + reserved files). */
export enum CourseAdminIntentEnum {
  Save = 'save',
  Abort = 'abort',
}

export enum ActionTypeEnum {
  status = 'status',
  create = 'create',
  delete = 'delete',
  edit = 'edit',
  download = 'download',
  enableDisable = 'enableDisable',
  photo = 'photo',
  orderUp = 'orderUp',
  orderDown = 'orderDown',
  showHide = 'showHide',
  totalAmount = 'totalAmount',
  send = 'send',
  get = 'get',
  sync = 'sync',
}
export type ActionType = EnumObjectValues<typeof ActionTypeEnum>
export type ActionKeysType = EnumObjectKeys<typeof ActionTypeEnum>

export const PaymentEnum = {
  PAYPAL: 'paypal',
  STRIPE: 'stripe',
} as const
export type PaymentType = EnumObjectValues<typeof PaymentEnum>
export type PaymentKeysType = EnumObjectKeys<typeof PaymentEnum>

export const PaymentMethodEnum = {
  STRIPE: 'card',
  PAYPAL: 'paypal',
  COUPON: 'coupon',
  KLARNA: 'klarna',
  BIZUM: 'bizum',
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
} as const
export type PaymentMethodEnumType = EnumObjectValues<typeof PaymentMethodEnum>

export const NotificationEventEnum = {
  AFTER_BUY: 'Después de la compra',
  AFTER_REFERRAL_FIRST_BUY: 'Después de la primera compra con invitación',
  BEFORE_SESSION: 'Antes de la sesión',
  AFTER_SESSION: 'Después de la sesión',
  RESCHEDULE_SESSION: 'Después de reprogramar sesión',
  CANCEL_SESSION: 'Después de cancelar sesión',
  LATE_ON_VIDEO_CALL: 'Al llegar tarde en una videollamada',
  AFTER_UPLOAD_SESSIONFILE: 'Después subir un archivo de sesión',
  WHEN_START_SESSION_RECORDING: 'Al empezar a grabar una sesión',
  WHEN_GOOGLE_CALENDAR_TOKEN_EXPIRE:
    'Cuando caduca el token de google calendar',
  AFTER_SPECIAL_SERVICE_BUY: 'Después de la compra de servicios especiales',
  SPECIAL_SERVICE_GIFT: 'Regalo de servicio especial',
  UNREAD_MESSAGES: 'Mensajes no leídos',
  AFTER_COURSE_BUY: 'Después de comprar un curso',
  AFTER_COURSE_COMPLETE: 'Después de completar un curso',
} as const
export type NotificationEventType = EnumObjectValues<
  typeof NotificationEventEnum
>
export type NotificationEventKeysType = EnumObjectKeys<
  typeof NotificationEventEnum
>

export const IVAEnum = {
  YES: 'Si',
  NO: 'No',
} as const
export type IVAType = EnumObjectValues<typeof IVAEnum>
export type IVAKeysType = EnumObjectKeys<typeof IVAEnum>

export const IrpfEnum = {
  '0%': 0,
  '7%': 7,
  '15%': 15,
} as const
export type IrpfType = EnumObjectValues<typeof IrpfEnum>
export type IrpfKeysType = EnumObjectKeys<typeof IrpfEnum>

export const NotificationStatusEnum = {
  PENDING: 'pending',
  SENDED: 'sended',
  ERROR: 'error',
} as const
export type NotificationStatusType = EnumObjectValues<
  typeof NotificationStatusEnum
>
export type NotificationStatusKeysType = EnumObjectKeys<
  typeof NotificationStatusEnum
>

export const DiscountStatusEnum = {
  ACTIVE: 'active',
  USED: 'used',
  EXPIRED: 'expired',
  PENDING: 'pending',
} as const
export type DiscountStatusType = EnumObjectValues<typeof DiscountStatusEnum>
export type DiscountStatusKeysType = EnumObjectKeys<typeof DiscountStatusEnum>

export const EnvEnum = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEV: 'dev',
} as const
export type ModeEnvType = EnumObjectValues<typeof EnvEnum>
export type ModeEnvKeysType = EnumObjectKeys<typeof EnvEnum>

export enum PaymentErrorEnum {
  GENERIC = 'true',
  PAYMENT = 'payment', // if payment was made but there was a error creating db data
  SESSION_EXIST = 'sessionExist', // if payment was made but session already exist
}
export type PaymentErrorEnumType = EnumObjectValues<typeof PaymentErrorEnum>
export type PaymentErrorEnumKeysType = EnumObjectKeys<typeof PaymentErrorEnum>

export const HomeFilterEnum = {
  CATEGORIES: 'categories',
  HOUR: 'hour',
  PRICE: 'price',
  TODAY: 'today',
  TOPICS: 'topics',
  TYPE: 'type',
  LANGUAGE: 'language',
  SEARCH: 'search',
  PAGE: 'page',
} as const
export type HomeFilterEnumType = EnumObjectValues<typeof HomeFilterEnum>

export const SpecialServicesEnum = {
  NATALCHART: 'Natal Chart',
  MYSTICCHART: 'Tu Carta Mística',
} as const
export type SpecialServicesType = EnumObjectValues<typeof SpecialServicesEnum>
export type SpecialServicesKeysType = EnumObjectKeys<typeof SpecialServicesEnum>
export const SessionTypeEnum = {
  WRITTEN: 'escrito',
  VIDEO_CALL: 'videollamada',
} as const

export const StatusInvoiceEnum = {
  PAID: 'paid',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  DELETED: 'deleted',
  BILLABLE: 'billable',
} as const
export type StatusInvoiceType = EnumObjectValues<typeof StatusInvoiceEnum>
export type StatusInvoiceKeysType = EnumObjectKeys<typeof StatusInvoiceEnum>

export const CurrencyEnum = {
  EUR: 'EUR',
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  FJD: 'FJD',
  FKP: 'FKP',
  FOK: 'FOK',
  GBP: 'GBP',
  GEL: 'GEL',
  GGP: 'GGP',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  IMP: 'IMP',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JEP: 'JEP',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KID: 'KID',
  KMF: 'KMF',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLE: 'SLE',
  SLL: 'SLL',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STN: 'STN',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TVD: 'TVD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XCD: 'XCD',
  XDR: 'XDR',
  XOF: 'XOF',
  XPF: 'XPF',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWL: 'ZWL',
} as const
export type CurrencyEnumEnumType = EnumObjectValues<typeof CurrencyEnum>

export const StripeSupportedCountriesEnum = {
  // Países de tu lista original
  AF: 'Afganistán',
  AL: 'Albania',
  DE: 'Alemania',
  AD: 'Andorra',
  AR: 'Argentina',
  AU: 'Australia',
  AT: 'Austria',
  BE: 'Bélgica',
  BO: 'Bolivia, Estado Plurinacional de',
  BR: 'Brasil',
  CA: 'Canadá',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  DK: 'Dinamarca',
  EC: 'Ecuador',
  EG: 'Egipto',
  AE: 'Emiratos Árabes Unidos',
  SI: 'Eslovenia',
  ES: 'España',
  US: 'Estados Unidos',
  EE: 'Estonia',
  FR: 'Francia',
  GQ: 'Guinea Ecuatorial',
  HU: 'Hungría',
  IR: 'Irán, República Islámica de',
  IE: 'Irlanda',
  IS: 'Islandia',
  FK: 'Islas Malvinas (Falkland)',
  IL: 'Israel',
  IT: 'Italia',
  JP: 'Japón',
  LU: 'Luxemburgo',
  MT: 'Malta',
  MU: 'Mauricio',
  MX: 'México',
  NO: 'Noruega',
  NZ: 'Nueva Zelanda',
  NL: 'Países Bajos',
  PA: 'Panamá',
  PY: 'Paraguay',
  PE: 'Perú',
  PL: 'Polonia',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  GB: 'Reino Unido',
  DO: 'República Dominicana',
  RO: 'Rumania',
  ZA: 'Sudáfrica',
  SE: 'Suecia',
  TR: 'Turquía',
  UA: 'Ucrania',
  UY: 'Uruguay',
  VE: 'Venezuela, República Bolivariana de',

  // Países soportados por Stripe
  BG: 'Bulgaria',
  CH: 'Suiza',
  CY: 'Chipre',
  CZ: 'República Checa',
  FI: 'Finlandia',
  GI: 'Gibraltar',
  GR: 'Grecia',
  HK: 'Hong Kong',
  HR: 'Croacia',
  LI: 'Liechtenstein',
  LT: 'Lituania',
  LV: 'Letonia',
  MC: 'Mónaco',
  MY: 'Malasia',
  SG: 'Singapur',
  SK: 'Eslovaquia',

  // Países de América Latina adicionales
  GT: 'Guatemala',
  SV: 'El Salvador',
  HN: 'Honduras',
  NI: 'Nicaragua',
  HT: 'Haití',
  JM: 'Jamaica',
  TT: 'Trinidad y Tobago',
  BB: 'Barbados',
  GD: 'Granada',
  LC: 'Santa Lucía',
  VC: 'San Vicente y las Granadinas',
  AG: 'Antigua y Barbuda',
  BS: 'Bahamas',
  BZ: 'Belice',
  SR: 'Surinam',
  GY: 'Guyana',

  // Países de Asia adicionales
  IN: 'India',
  TH: 'Tailandia',
  VN: 'Vietnam',
  PH: 'Filipinas',
  ID: 'Indonesia',
  BN: 'Brunéi',
  KH: 'Camboya',
  LA: 'Laos',
  MM: 'Myanmar',
  BD: 'Bangladesh',
  LK: 'Sri Lanka',
  MV: 'Maldivas',
  NP: 'Nepal',
  BT: 'Bután',
  PK: 'Pakistán',
  IQ: 'Irak',
  SY: 'Siria',
  JO: 'Jordania',
  LB: 'Líbano',
  PS: 'Palestina',
  SA: 'Arabia Saudita',
  YE: 'Yemen',
  OM: 'Omán',
  BH: 'Bahréin',
  KW: 'Kuwait',
  GE: 'Georgia',
  AM: 'Armenia',
  AZ: 'Azerbaiyán',
  KZ: 'Kazajstán',
  UZ: 'Uzbekistán',
  TM: 'Turkmenistán',
  KG: 'Kirguistán',
  TJ: 'Tayikistán',
  MN: 'Mongolia',
  TW: 'Taiwán',
  KR: 'Corea del Sur',
  KP: 'Corea del Norte',
  RU: 'Rusia',
  BY: 'Bielorrusia',
  MD: 'Moldavia',

  // Países de Europa adicionales
  RS: 'Serbia',
  ME: 'Montenegro',
  BA: 'Bosnia y Herzegovina',
  MK: 'Macedonia del Norte',
  XK: 'Kosovo',

  // Países de África adicionales
  LY: 'Libia',
  TN: 'Túnez',
  DZ: 'Argelia',
  MA: 'Marruecos',
  EH: 'Sahara Occidental',
  MR: 'Mauritania',
  ML: 'Malí',
  NE: 'Níger',
  NG: 'Nigeria',
  TD: 'Chad',
  SD: 'Sudán',
  ET: 'Etiopía',
  ER: 'Eritrea',
  DJ: 'Yibuti',
  SO: 'Somalia',
  KE: 'Kenia',
  UG: 'Uganda',
  RW: 'Ruanda',
  BI: 'Burundi',
  TZ: 'Tanzania',
  MW: 'Malawi',
  ZM: 'Zambia',
  ZW: 'Zimbabue',
  BW: 'Botswana',
  NA: 'Namibia',
  LS: 'Lesoto',
  SZ: 'Suazilandia',
  MZ: 'Mozambique',
  MG: 'Madagascar',
  SC: 'Seychelles',
  KM: 'Comoras',
  YT: 'Mayotte',
  RE: 'Reunión',
  AO: 'Angola',
  CD: 'República Democrática del Congo',
  CF: 'República Centroafricana',
  CM: 'Camerún',
  CG: 'Congo',
  GA: 'Gabón',
  ST: 'Santo Tomé y Príncipe',
  GH: 'Ghana',
  CI: 'Costa de Marfil',
  BF: 'Burkina Faso',
  SN: 'Senegal',
  GM: 'Gambia',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  SL: 'Sierra Leona',
  LR: 'Liberia',
  TG: 'Togo',
  BJ: 'Benín',
  CV: 'Cabo Verde',

  // Países de Oceanía adicionales
  FJ: 'Fiyi',
  PG: 'Papua Nueva Guinea',
  SB: 'Islas Salomón',
  VU: 'Vanuatu',
  NC: 'Nueva Caledonia',
  PF: 'Polinesia Francesa',
  WF: 'Wallis y Futuna',
  TO: 'Tonga',
  TV: 'Tuvalu',
  KI: 'Kiribati',
  NR: 'Nauru',
  PW: 'Palaos',
  FM: 'Micronesia',
  MH: 'Islas Marshall',
  GU: 'Guam',
  MP: 'Islas Marianas del Norte',
  AS: 'Samoa Americana',
  CK: 'Islas Cook',
  NU: 'Niue',
  TK: 'Tokelau',
  WS: 'Samoa',
} as const
export type StripeSupportedCountriesType = EnumObjectValues<
  typeof StripeSupportedCountriesEnum
>
export type StripeSupportedCountriesKeysType = EnumObjectKeys<
  typeof StripeSupportedCountriesEnum
>
